
import { Component, Prop, Vue } from "vue-property-decorator";
import { ElTabPane } from "element-ui/types/tab-pane";
import Url from "@/lib/common/url";
import ExamList from "@/components/exam/list.vue";

class Item {
  name = "";
  label = "";
  url = "";
}

@Component({
  components: {
    ExamList
  }
})
export default class MenuTab extends Vue {
  @Prop({ type: String, default: "" }) activeName!: string;
  name = "menu-tab";
  items: Item[] = [
    {
      name: "我创建的面试",
      label: "我创建的面试",
      url: ""
    },
    {
      name: "我参与的面试",
      label: "我参与的面试",
      url: ""
    },
    {
      name: "公司全部面试",
      label: "公司全部面试",
      url: ""
    },
    {
      name: "排队面试",
      label: "排队面试",
      url: ""
    },
    {
      name: "群面",
      label: "群面",
      url: ""
    },
    {
      name: "空中宣讲",
      label: "空中宣讲",
      url: ""
    },
    {
      name: "preach",
      label: "AI是面试",
      url: "/list/preach"
    },
    {
      name: "exam",
      label: "在线笔试",
      url: "/list/exam"
    }
  ];
  handleClick(tab: ElTabPane) {
    Url.setQuery("activeName", tab.name);
  }
}
